import { useState } from "react";
import PropTypes from "prop-types";
import { useMutation } from "react-query";
import { postData } from "../../../api/api";
import { getQueryConfiguration } from "../../../utils";
import ForgotPasswordSentDialog from "./ForgotPasswordSentDialog";
import ForgotPasswordEntryDialog from "./ForgotPasswordEntryDialog";

const ForgotPasswordDialog = (props) => {
    const [email, setEmail] = useState();
    const [message, setMessage] = useState();
    const [sent, setSent] = useState(false);
    const [mutationError, setMutationError] = useState();

    const { applicationId } = getQueryConfiguration();

    const mutation = useMutation((resource) => postData("/accounts/forgot-password", resource), {
        onMutate: () => {
            setMessage();
        },
        onSuccess: () => {
            props.onClose?.();
            setMessage("Security email has been sent.");
            setSent(true);
        },
        onError: (error) => {
            setMutationError(error.response.data.message);
        },
    });

    const handleSave = (email) => {
        mutation.mutate({
            email,
            applicationId,
        });
    };

    const handleCloseSentDialog = () => {
        setSent(false);
        props.onCancel();
    };

    if (sent) {
        return (
            <ForgotPasswordSentDialog
                open={true}
                email={email}
                onBack={handleCloseSentDialog}
                //
            />
        );
    } else {
        return (
            <ForgotPasswordEntryDialog
                open={props.open}
                email={email}
                setEmail={setEmail}
                saving={mutation.isLoading}
                message={message}
                error={mutationError}
                onSave={handleSave}
                onCancel={props.onCancel}
            />
        );
    }
};

ForgotPasswordDialog.propTypes = {
    onClose: PropTypes.func,
};

export default ForgotPasswordDialog;
